



















export default {
	name: 'ButtonSecondary',

	props: {
		name: {
			required: false,
			type: String,
		},
		text: {
			required: false,
			type: String,
		},
		icon: {
			required: false,
			type: String,
		},
		disabled: {
			required: false,
			type: Boolean,
		},
		type: {
			default: 'button',
			required: false,
			type: String,
		},
		small: {
			default: false,
			required: false,
			type: Boolean,
		},
		loading: {
			default: false,
			required: false,
			type: Boolean,
		},
	},
};
